import type { RiskBand, RiskBandSet, RiskBandStatus, RiskRatingValues } from '@gcv/shared';
import { injectable } from 'inversify';

import { banksApi } from './api-util/api';

/** Structured filters for the risk band set list. Sent in the request body — see queryRiskBandSets. */
export interface RiskBandSetQuery {
  status?: RiskBandStatus;
  /** Versions to return, e.g. ['draft', 'latest', '1']. Omit for the active 'latest' only. */
  versions?: string[];
  /** When true, return only the most-recently-updated version of each logical band set. */
  last_updated_only?: boolean;
}

export interface CreateRiskBandSetPayload {
  name: string;
  description?: string;
  bands?: RiskBand[];
  rating_values?: RiskRatingValues;
}

export interface UpdateRiskBandSetPayload {
  name: string;
  description?: string;
  bands?: RiskBand[];
  rating_values?: RiskRatingValues;
}

@injectable()
export class RiskBandsApi {
  async queryRiskBandSets(bankId: string, query?: RiskBandSetQuery): Promise<RiskBandSet[]> {
    return await banksApi().post(`/banks/${bankId}/risk-bands/query`, query ?? {});
  }

  async createRiskBandSet(bankId: string, data: CreateRiskBandSetPayload): Promise<RiskBandSet> {
    return await banksApi().post(`/banks/${bankId}/risk-bands`, data);
  }

  async updateRiskBandSet(bankId: string, id: string, data: UpdateRiskBandSetPayload): Promise<RiskBandSet> {
    return await banksApi().put(`/banks/${bankId}/risk-bands/${id}`, data);
  }

  async publishRiskBandSet(bankId: string, id: string): Promise<RiskBandSet> {
    return await banksApi().post(`/banks/${bankId}/risk-bands/${id}/publish`, {});
  }
}
